import { getMySummaryOneOnOneApi, getMySummaryOOOApi } from '../api';

export const getMySummaryOneOnOn = async ({ employeeId, limit = 3, offset = 0 }) => {
  try {
    const res = await getMySummaryOneOnOneApi({ employeeId, limit, offset });
    return res?.entity;
  } catch (error) {
    console.error('Error fetching my summary for 1:1 : ', error);
  }
};

export const getMySummaryOOO = async ({ employeeId, limit = 3, offset = 0 }) => {
  try {
    const res = await getMySummaryOOOApi({ employeeId, limit, offset });
    return res?.entity;
  } catch (error) {
    console.error('Error fetching my summary for OOO : ', error);
  }
};
